// Popups « Développeur supplémentaire » et « Session supplémentaire » de la page Offres.
// Un seul modal partagé par type : au clic, clone le template Blade correspondant à l'offre
// dans le conteneur du modal. Flowbite gère l'ouverture via data-modal-target/toggle.

const wirePopup = (
    triggerAttr: string,
    contentId: string,
    tplAttr: string,
    modalId: string
): void => {
    const content = document.getElementById(contentId);
    if (!content) return;

    document.querySelectorAll<HTMLElement>(`[${triggerAttr}]`).forEach((btn) => {
        btn.addEventListener('click', () => {
            const key = btn.getAttribute(triggerAttr);
            const tpl = document.querySelector<HTMLTemplateElement>(
                `template[${tplAttr}="${key}"]`
            );
            if (!tpl) return;
            content.innerHTML = '';
            content.appendChild(tpl.content.cloneNode(true));

            // Un éventuel lien Early Adopter cloné ferme aussi la popup : le contenu injecté
            // n'est pas lié par Flowbite, on déclenche le bouton de fermeture du modal.
            content
                .querySelector<HTMLAnchorElement>('a[href="#early-adopter"]')
                ?.addEventListener('click', () => {
                    document
                        .querySelector<HTMLElement>(`#${modalId} [data-modal-hide="${modalId}"]`)
                        ?.click();
                });
        });
    });
};

// Deep-link : #<offre>-<type> (ex. #bronze-developer, #gold-session) ouvre la popup
// correspondante en cliquant son déclencheur (réutilise clone du template + ouverture Flowbite).
const openFromHash = (): void => {
    const m = location.hash.match(/^#(bronze|silver|gold)-(developer|session)$/);
    if (!m) return;
    const attr = m[2] === 'developer' ? 'data-devsup' : 'data-session';
    document.querySelector<HTMLElement>(`[${attr}="${m[1]}"]`)?.click();
};

export const initOffersDevSupModal = (): void => {
    // Un SEUL modal partagé (dev-sup-modal) pour les 2 popups : un 2e modal dupliquerait
    // les IDs SVG du backdrop light et casserait le fond. Les sessions clonent donc aussi
    // dans #dev-sup-content.
    wirePopup('data-devsup', 'dev-sup-content', 'data-devsup-tpl', 'dev-sup-modal');
    wirePopup('data-session', 'dev-sup-content', 'data-session-tpl', 'dev-sup-modal');

    // Ouverture par ancre : au chargement (Flowbite est déjà initialisé) + à chaque hashchange.
    window.addEventListener('hashchange', openFromHash);
    openFromHash();
};
